import actions from "@/store/modules/user-group/actions";
import mutations from "@/store/modules/user-group/mutations";
import state from "@/store/modules/user-group/state";

export default {
    actions,
    mutations,
    state
}